import { BrandLoader } from '@/components/common/BrandLoader';
import { APP_NAME } from '@/constants/app.constants';
import { LoginBackground } from './LoginBackground';
import { useSsoLogin } from '../hooks/useSsoLogin';

export function SsoPage() {
  useSsoLogin();

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-auth-surface px-4 py-10">
      <LoginBackground />

      <div className="relative flex w-full max-w-md flex-col items-center gap-8 rounded-3xl bg-card/97 px-6 py-12 shadow-[0_4px_16px_var(--color-auth-glow)] sm:px-10">
        <BrandLoader />

        <div className="flex flex-col items-center gap-2 text-center">
          <h1 className="text-[26px]/6 font-semibold text-foreground">Signing you in</h1>
          <p className="text-sm text-muted-foreground">Taking you through to {APP_NAME}</p>
        </div>
      </div>
    </div>
  );
}
